//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import slugify from 'slugify'
import { capitalizeFirstLetter } from '~/utils/utils'

export default {
  props: {
    type: {
      type: String,
      default: 'default'
    },
    boatType: {
      type: Object,
      default: null
    },
    location: {
      type: Object,
      default: () => {
      }
    },
    searchTerms: {
      type: Object,
      default: () => {
      }
    },
    order: {
      type: Array,
      default: () => []
    },
    route: {
      type: [String, Object],
      default: () => {
      }
    },
    season: {
      type: Object,
      default: () => {
      }
    }
  },
  computed: {
    ...mapState({
      breadcrumbs: 'breadcrumbs'
    }),
    getBreadcrumbs () {
      if (this.type === 'default') {
        if (!this.breadcrumbs) {
          return
        }
        return this.breadcrumbs.map((cr) => {
          return {
            ...cr,
            component: cr.url === this.$route.path ? 'span' : 'nuxt-link'
          }
        })
      } else if (this.type === 'search') {
        const result = this.order.map((cr) => {
          const locationUrl = this.location.urls[cr]
          let url = this.$router.resolve({ ...this.route, params: { location: locationUrl } }).href
          if (locationUrl === 'world') {
            url = null
          }
          const title = this.location.location[cr]
          return {
            url,
            title,
            component: (url === this.$route.path || !url) ? 'span' : 'nuxt-link'
          }
        })
        if (this.boatType) {
          const cr = this.order[this.order.length - 1]
          result.push({
            title: capitalizeFirstLetter(this.boatType.name),
            url: this.$router.resolve({
              name: 'destination-location-boat', params: { lang: this?.$store?.state?.lang?.locale || 'en', location: this.location.urls[cr], boatType: this.boatType.slug }
            }).href,
            component: 'nuxt-link'
          })
        }
        return result
      } else if (this.type === 'boat') {
        // if (!this.season?.marina?.name && !this.season?.marina?.slug) {
        //   return
        // }

        const result = []

        function getSlug (location) {
          return location.slug || slugify(location.name.toLowerCase())
        }

        result.push({
          title: this.$t('home'),
          url: this.$router.resolve({
            name: 'index', params: { lang: this?.$store?.state?.lang?.locale || 'en' }
          }).href,
          component: 'nuxt-link'
        })

        if (this.season.country.name !== undefined) {
          result.push({
            title: this.season.country.name,
            url: this.$router.resolve({ name: 'destination-location', params: { location: getSlug(this.season.country) } }).href,
            component: 'nuxt-link'
          })
        }

        result.push({
          title: this.season.city.name !== '' ? this.season.city.name : this.season.region.name,
          url: this.$router.resolve({
            name: 'destination-location',
            params: { location: getSlug(this.season.city.name !== '' ? this.season.city : this.season.region) }
          }).href,
          component: 'nuxt-link'
        })

        result.push({
          title: this.season.marina.name || capitalizeFirstLetter(this.season.marina?.slug?.replace(/-/g, ' ') || ''),
          url: this.$router.resolve({ name: 'destination-location', params: { location: getSlug(this.season.marina) } }).href,
          component: 'span'
        })

        return result
      }
    }
  },
  jsonld () {
    const items = this.getBreadcrumbs.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      item: process.env.appUrl + item.url,
      name: item.title || 'Tubber'
    }))
    return {
      '@context': 'http://schema.org',
      '@type': 'BreadcrumbList',
      name: 'Tubber',
      itemListElement: items
    }
  }
}
